import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { Settlement } from './Settlement.js';
/**
 * Links a payment to a settlement it was part of. One payment can appear in multiple settlements
 * (e.g. the payment in one payout, its refund in a later payout).
 */
export class PaymentSettlement extends AutoEncoder {
    id;
    settlementId;
    paymentId;
    /**
     * Signed effect of this payment on the payout amount.
     */
    amount = 0;
    externalId;
    /**
     * When the provider moved the money (not the same as payments.paidAt).
     */
    occurredAt;
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], PaymentSettlement.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], PaymentSettlement.prototype, "settlementId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], PaymentSettlement.prototype, "paymentId", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], PaymentSettlement.prototype, "amount", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PaymentSettlement.prototype, "externalId", void 0);
__decorate([
    field({ decoder: DateDecoder })
], PaymentSettlement.prototype, "occurredAt", void 0);
export class PaymentSettlementDetailed extends PaymentSettlement {
    settlement;
}
__decorate([
    field({ decoder: Settlement })
], PaymentSettlementDetailed.prototype, "settlement", void 0);
//# sourceMappingURL=PaymentSettlement.js.map